module.exports = __webpack_public_path__ + "img/AMOL.9b46d7b1.svg";